// extracted by mini-css-extract-plugin
module.exports = {"tablist":"TabList_tablist_GLryJ","item":"TabList_item_3AKCG","button":"TabList_button_1Lbzw","active":"TabList_active_2jfxU"};